module.exports = __webpack_public_path__ + "media/15_BL.1b326ebb.mp3";